import { HttpContextToken } from '@angular/common/http';

/** Prevents the connected-user header on requests that must resolve against the original administrator. */
export const SKIP_ADMIN_CONNECTION_CONTEXT: HttpContextToken<boolean> = new HttpContextToken<boolean>(() => false);
